export const FIRST_PAYMENT_DATE_WARNING = 'Since the First Payment Date is earlier than the Deal Start Date' 
    + ' it will be automatically adjusted to match the Deal Start Date.'
export const COMMISION_DUE_DATE_WARNING = 'Since the Commission Due Date is earlier than the Deal Start Date' 
    + ' it has been automatically adjusted to match the Deal Start Date.'
export const COMMISSION_WAS_PAID_WARNING = 'This commission has already been paid. If you want to change the payment date,'
    + ' first remove this commission completely.'